/**
 * This file defines low level API requests to interact with the CyberAudit-Web
 * server.
 */

import axios from "axios";

const config = {
    timeout: 60 * 1000, // 60 seconds
    headers: {
        'Content-Type': 'application/json'
    },
}

const handleError = (error, callback) => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        callback(error.response);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        callback(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        callback(error.message);
    }
};

export const postData = (url, callback, additionalConfig, body) => {
    let getConfig = {
        ...config,
        ...additionalConfig
    };

    let urlToUse = url;
    let csrfTokenEls = document.getElementsByName('_CSRFToken');
    if (csrfTokenEls) {
        const csrfToken = csrfTokenEls[0]?.value;
        if (csrfToken && csrfToken !== "") {
            urlToUse += `&_CSRFToken=${csrfToken}`;
        }
    }

    axios
        .post(urlToUse, body || {}, getConfig)
        .then(response => {
            callback(response);
        })
        .catch(error => {
            handleError(error, callback);
        })
}

export const getData = (url, callback, additionalConfig) => {
    let getConfig = {
        ...config,
        ...additionalConfig
    };

    axios
        .get(url, getConfig)
        .then(response => callback(response))
        .catch(error => {
            handleError(error, callback);
        })
}

export const putData = (url, body, callback, additionalConfig) => {
    let getConfig = {
        ...config,
        ...additionalConfig
    };
    config.headers._CSRFToken = getCsrfToken();

    axios
        .put(url, body, getConfig)
        .then(response => callback(response))
        .catch(error => {
            callback(error);
        })
}

export const deleteData = (url, callback) => {
    config.headers._CSRFToken = getCsrfToken();
    axios
        .delete(url, config)
        .then(response => callback(response))
        .catch(error => {
            callback(error);
        })
}

export const getCsrfToken = () => {
    const csrfTokens = document.getElementsByName('_CSRFToken');
    if (!csrfTokens || csrfTokens.length === 0)
    {
        return null;
    }
    return csrfTokens[0].value;
};